module.exports = __webpack_public_path__ + "img/discount_off.a6c81765.svg";